import { importRemote } from '@module-federation/utilities';
import { Application, LifeCycles, registerApplication, RegisterApplicationConfig, start } from 'single-spa';
import { constructApplications, constructLayoutEngine, constructRoutes } from 'single-spa-layout';
import singleSpaReact from 'single-spa-react';
import React from 'react';
import ReactDOMClient from 'react-dom/client';
import store, { rootReducer } from '../redux/store';
import { ModuleFederationConfig } from '../types/ImportMap';

export const buildApplications = (routes?: unknown) => {
  if (!routes) {
    return [];
  }
  return constructApplications({
    routes: routes,
    loadApp: async ({ name }) => {
      const { scope, url, module, remoteEntryFileName } = window.singleSpaLayoutData.props[name] as ModuleFederationConfig;
      const urlObj = new URL(url, window.location.origin);
      return importRemote<{ default: Application }>({
        url: `${urlObj.href}`,
        scope,
        module,
        remoteEntryFileName,
        bustRemoteEntryCache: false
      })
        .then((props) => props.default)
        .then((app) => {
          if ((app as LifeCycles).bootstrap) {
            return app;
          } else {
            const Component = app as unknown as React.FC;
            return singleSpaReact({ React, ReactDOMClient, rootComponent: () => <Component /> });
          }
        })
        .catch((err) => {
          console.error(err);
          return singleSpaReact({ React, ReactDOMClient, rootComponent: () => <div></div> });
        }) as Promise<Application>;
    }
  });
};

// This is the containing element for the micro frontends
const appLayoutElement = document.querySelector('#app-layout');

const routes = appLayoutElement ? constructRoutes(appLayoutElement) : undefined;

const isBuiltInApplication = (app: RegisterApplicationConfig) => !app.name.startsWith('mfe');
if (routes) {
  const applications = buildApplications(routes);

  // ensure assembler application load first
  const sortedApplications = applications.sort((a) => (isBuiltInApplication(a) ? -1 : 1));

  sortedApplications.forEach((app) => {
    const customPropsWithStore = (...args: string[]) => {
      // eslint-disable-next-line @typescript-eslint/ban-types
      return { ...(app.customProps as Function)(args), store: { store }, rootReducer: { rootReducer } };
    };

    registerApplication({ ...app, customProps: customPropsWithStore });
  });

  constructLayoutEngine({ routes, applications: sortedApplications });
}

start();
// graphQL

if (window.graphConsolidation?.isEnabled) {
  import('../server/utils/consolidate-query').then(({ default: consolidateQuery }) => {
    consolidateQuery();
  });
}
